import formsReducer, {
  disableForm,
  enableForm,
  clearForm,
  setFormErrors
} from "../lib/formsReducer";
import entitiesReducer from "../lib/entitiesReducer";
import * as actions from "./actions";
import { Record, Map } from "immutable";
import { isApiCall } from "../app/schema";

import Forms from "./forms";
import CategoriesTranslations from "./categoriesTranslations";

const feature = "categoriesTranslations";

const InitialState = Record({
  forms: new Forms(),
  categoriesTranslations: new CategoriesTranslations()
});

const initialState = new InitialState();

function revive() {
  return initialState.merge({});
}

export default function CategoriesTranslationsReducer(
  state = initialState,
  action
) {
  if (!(state instanceof InitialState)) return revive(state);

  if (isApiCall(action.type)) {
    if (
      action.payload &&
        action.payload.entities &&
        action.payload.entities.categoriesTranslations
    ) {
      state = state.updateIn(
        ["categoriesTranslations", "entities"],
        map => map.mergeDeep(action.payload.entities.categoriesTranslations)
      );
    }
  }

  switch (action.type) {
    case actions.POST_CATEGORIES_TRANSLATIONS: {
      return disableForm(state, "createCategoryTranslation");
    }
    case actions.POST_CATEGORIES_TRANSLATIONS_SUCCESS: {
      state = clearForm(state, "createCategoryTranslation", Forms);
      return enableForm(state, "createCategoryTranslation");
    }
    case actions.POST_CATEGORIES_TRANSLATIONS_ERROR: {
      state = enableForm(state, "createCategoryTranslation");
      return setFormErrors(
        state,
        "createCategoryTranslation",
        action.payload.errors
      );
    }

    case actions.PATCH_CATEGORY_TRANSLATION: {
      return state.setIn(["categoriesTranslations", "loading"], true);
    }
    case actions.PATCH_CATEGORY_TRANSLATION_SUCCESS: {
      return state.setIn(["categoriesTranslations", "loading"], false);
    }
    case actions.PATCH_CATEGORY_TRANSLATION_ERROR: {
      return state.setIn(["categoriesTranslations", "loading"], false);
    }

    case actions.DELETE_CATEGORY_TRANSLATION: {
      return state.deleteIn([
        "categoriesTranslations",
        "entities",
        action.payload.uid
      ]);
    }

  }

  return entitiesReducer(
    formsReducer(state, feature, action, Forms),
    feature,
    action
  );
}



// WEBPACK FOOTER //
// ./src/common/categoriesTranslations/reducer.js